module.exports = __webpack_public_path__ + "img/document.e79144ae.svg";